/*
 * Template for error/success message,
 * Show/hide error message when required,
 * Show/hide success message when required.
 * 
 */

(function(window, angular, undefined) {

  'use strict';

  angular.module('ngAngularError', ['ng', 'ngResource'])
    .factory('list', function($http) {
      /* errors_list.json should contain a map of errors and user-feedback.
       * we use, $http to retrieve values from file errors_list.json,
       * errorsList factory returns a promise. */
      return $http.get('errors_list.json');
    })
    .directive('awesomeError', function (list) {
      return {
        restrict: 'E',
        replace: true,
        scope: {
        	target: '='
        },
//        template: '<div> \
//                      <div data-ng-class="{ \'in\': showErr==true || showSucc==true, \'alert-danger\': showErr==true, \'alert-success\': showSucc==true}"  class="alert fade"> \
//                        <i data-ng-class="{ \'icon-ok-sign\': showSucc==true, \'icon-warning-sign\': showErr==true}" class="dummmy"></i>\
//                        {{showMessage}} \
//                    </div> \
//                   </div>',
        template: '<div> \
            <div data-ng-cloak data-ng-show="showErr==true" data-ng-hide="showErr==false" data-ng-animate="\'fade\'" data-ng-class="{ \'alert-danger\': showErr==true }"  class="alert"> \
				<i ng-cloak data-ng-class="{ \'icon-ok-sign\': showSucc==true, \'icon-warning-sign\': showErr==true}" class="dummmy"></i>\
				{{showMessage}} \
        	</div> \
        	<div data-ng-cloak data-ng-show="showSucc==true" data-ng-hide="showSucc==false" data-ng-animate="\'fade\'" data-ng-class="{ \'alert-success\': showSucc==true}"  class="alert"> \
	            <i ng-cloak data-ng-class="{ \'icon-ok-sign\': showSucc==true, \'icon-warning-sign\': showErr==true}" class="dummmy"></i>\
	            {{showMessage}} \
        	</div>',
                   
                   
        link: function(scope) {

          scope.messageMap = {};

          var _showMsg = function(val, args, target, str, additionalInfo) {
            if (scope.target === target) {
              if (!str) {
                str = 'Undefined';
              }
              scope.showMessage = scope.messageMap[str];
              if(additionalInfo!="" && !(additionalInfo===undefined)){
            	  scope.showMessage += " " + additionalInfo;
              }
              if (args.name.indexOf('error') !== -1) {
                scope.showErr = val;
              } else {
                scope.showSucc = val;
              }
            }
          };

          /* fetching data present in 'errors-list.json' file */
          list.success(function(data) {
            scope.messageMap = data;
//            scope.target = scope.messageMap["target"];
          });

          scope.$on('show error', function (args, target, err, additionalInfo) {
        	  //first turning of the showSucc (otherwise the old color might be used)
        	  scope.showSucc = false;
        	  _showMsg(true, args, target, err, additionalInfo);
          });

          scope.$on('hide all', function(args, target) {
            scope.showErr = false;
            scope.showSucc = false;
          });
          
          scope.$on('show all', function(args, target) {
              scope.showErr = true;
              scope.showSucc = true;
            });

          scope.$on('hide error', function (args, target) {
            _showMsg(false, args, target);
          });

          scope.$on('show success', function (args, target, succ, additionalInfo) {
        	  //first turning of the showErr (otherwise the old color might be used)
        	  scope.showErr = false;
        	  _showMsg(true, args, target, succ, additionalInfo);
          });

          scope.$on('hide success', function (args, target) {
            _showMsg(false, args, target);
          });
          
          scope.$on('hide all after', function (args, target, time){
        	  setTimeout(function(){
                  scope.$broadcast('hide all', 'WebMAUSBasicStatus'); // to show error msg
               }, time); 
          });
          scope.$on('hide error after', function (args, target, time){
        	  setTimeout(function(){
                  scope.$broadcast('hide error', 'WebMAUSBasicStatus'); // to show error msg
               }, time); 
          });
          scope.$on('hide success after', function (args, target, time){
        	  setTimeout(function(){
                  scope.$broadcast('hide success', 'WebMAUSBasicStatus'); // to show error msg
               }, time); 
          });
        }
      };
    });
})(window, window.angular);
